"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _oneWeir = require("@weirgroup/one-weir");
var _reactRedux = require("react-redux");
var _weirDls = require("@weirgroup/weir-dls");
var _viewUsersconstants = require("./viewUsersconstants");
var _manageYourTeam = require("../manageYourTeam.action");
var _viewUsersModule = _interopRequireDefault(require("./viewUsers.module.css"));
var _languageMsg = _interopRequireDefault(require("./languageMsg"));
var _sortHelper = require("../../../shared/Helper/sortHelper");
var _constants = require("../constants");
var _common = require("../../../utilities/common");
class ViewUsersPage extends _react.default.Component {
  static deleteBodyContent(userName) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _viewUsersModule.default.modalText
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _viewUsersModule.default.contentOne
    }, "".concat(_languageMsg.default.DELETE_CONFIRMATION, " ").concat(userName, "?")));
  }
  constructor(props) {
    super(props);
    const assignedRoles = [...this.props.roles];
    assignedRoles.map(item => {
      Object.assign(item, {
        value: item.appRoleObjectId,
        label: item.appRoleDisplayName,
        name: item.appRoleDisplayName
      });
      return item;
    });
    this.state = {
      breadcrumbHistoryData: [],
      values: assignedRoles,
      onRoleChange: false
    };
    this.updateUsersAppRole = this.updateUsersAppRole.bind(this);
    this.onClickAddTeamMember = this.onClickAddTeamMember.bind(this);
  }
  componentDidMount() {
    const {
      businessEntity,
      applicationID
    } = this.props;
    this.props.getUsersForSelectedBusinessEntity(applicationID, businessEntity.businessEntityObjectId);
    this.breadcrumbInitialize();
  }
  componentDidUpdate(nextProps) {
    if (this.props.users && this.props.users.length > 0 && nextProps.roles && nextProps.roles.length > 0 && this.state.tableSrcData && this.state.tableSrcData.length === 0 && this.props.users !== nextProps.users) {
      this.getUserListData(this.props.users, nextProps.roles);
    } else if (this.props.users && this.props.users.length > 0 && this.props.users !== nextProps.users) {
      this.getUserListData(this.props.users, nextProps.roles);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.deleteUserData && nextProps.deleteUserData.email) {
      this.setState({
        userDisplayName: nextProps.deleteUserData.email
      });
    }
  }
  getUserListData(viewUsersData, rolesListData, isSort, sortOrder, sortKey) {
    if (isSort === undefined && sortOrder === undefined && sortKey === undefined) {
      isSort = true;
      sortOrder = 'downArrow';
      sortKey = 'status';
    }
    const dataList = viewUsersData;
    let data = [];
    if (dataList.length > 0) {
      if (dataList[0].userAppRoleAssignments !== undefined) {
        for (var i = 0; i < dataList[0].userAppRoleAssignments.length; i++) {
          for (var j = 0; j < dataList[0].userAppRoleAssignments[i].assignedUsers.length; j++) {
            data.push({
              objectId: dataList[0].userAppRoleAssignments[i].assignedUsers[j].userObjectId,
              displayName: dataList[0].userAppRoleAssignments[i].assignedUsers[j].displayName,
              email: dataList[0].userAppRoleAssignments[i].assignedUsers[j].email,
              status: dataList[0].userAppRoleAssignments[i].assignedUsers[j].status,
              appRoleObjectId: dataList[0].userAppRoleAssignments[i].appRoleObjectId,
              appRoleName: dataList[0].userAppRoleAssignments[i].appRoleName,
              lastLogin: dataList[0].userAppRoleAssignments[i].assignedUsers[j].lastLogin
            });
          }
        }
        if (data.length > 0) {
          const assignedRoles = data;
          assignedRoles.map(item => {
            Object.assign(item, {
              value: item.appRoleObjectId,
              label: item.appRoleName,
              name: item.appRoleName
            });
            return item;
          });
          this.state = {
            values: assignedRoles
          };
        }
      }
    }

    /* Below logic loads the table dynamic */
    /* V2 Table */
    const tableData = {
      tableHeaders: [{
        label: _viewUsersconstants.CONSTANTS.USERS,
        key: 'MineSiteUsers',
        type: 'string',
        sortable: true,
        filterable: true,
        renderFn: item => {
          return /*#__PURE__*/_react.default.createElement(_oneWeir.TitleContextCard, {
            "data-test": 'row-items',
            title: item.MineSiteUsers.value,
            context: item.MineSiteUsersEmail.value,
            contextPrefix: /*#__PURE__*/_react.default.createElement("div", {
              className: _viewUsersModule.default.iconAlign
            }, /*#__PURE__*/_react.default.createElement(_oneWeir.Icon, {
              width: "12px",
              height: "12px",
              icon: "mail"
            })),
            contextStyle: 'normal',
            active: 'true',
            callbackHandler: () => this.onClickUser(item)
          });
        }
      }, {
        label: _viewUsersconstants.CONSTANTS.STATUS,
        key: 'MineSiteUserStatus',
        type: 'string',
        sortable: true,
        filterable: true,
        renderFn: item => {
          const statusVal = item.MineSiteUserStatus.source ? item.MineSiteUserStatus.source.toLowerCase() : '-';
          if (statusVal.indexOf('remove') !== -1) {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: _viewUsersModule.default.removedCls
            }, item ? item.MineSiteUserStatus.value : '-');
          } else {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: _viewUsersModule.default.activeCls
            }, item ? item.MineSiteUserStatus.value : '-');
          }
        }
      }, {
        label: _viewUsersconstants.CONSTANTS.LAST_LOG_IN,
        key: 'MineSiteUserLastLogin',
        type: 'string',
        sortable: true,
        filterable: true
      }, {
        label: _viewUsersconstants.CONSTANTS.ROLE,
        key: 'MineSiteUserRole',
        sortable: true,
        filterable: true,
        renderFn: item => {
          var _rolesList$filter$;
          let rolesList = [];
          const roles = (0, _common.formatRoleDropDownValues)(rolesListData, 'appRoleDisplayName');
          rolesList = roles.roleNames.filter((thing, ind, self) => ind === self.findIndex(t => t.value === thing.value));
          let roleDropdownTemplate;
          const statusVal = item.MineSiteUserStatus.source ? item.MineSiteUserStatus.source.toLowerCase() : '-';
          let enableDsiableStatus = false;
          for (let i = 0; i < rolesList.length; i++) {
            if (rolesList[i].value.trim().toLowerCase() === item.MineSiteUserRole.source.trim().toLowerCase() && statusVal.indexOf('remove') === -1) {
              if (rolesList.length > 1) {
                enableDsiableStatus = true;
              }
            }
          }
          let valueofRoles = (_rolesList$filter$ = rolesList.filter(option => option.appRoleDisplayName === item.MineSiteUserRole.source)[0]) === null || _rolesList$filter$ === void 0 ? void 0 : _rolesList$filter$.value;
          roleDropdownTemplate = /*#__PURE__*/_react.default.createElement("div", {
            className: _viewUsersModule.default.paddingBottom8
          }, enableDsiableStatus ? /*#__PURE__*/_react.default.createElement(_weirDls.Dropdown, {
            selectData: rolesList,
            selectSize: 4,
            size: "md",
            name: "selectApp",
            clearable: false,
            placeholderText: _languageMsg.default.SELECT_APP_ROLE,
            setValue: e => {
              var _item$MineSiteUserRol;
              if ((item === null || item === void 0 || (_item$MineSiteUserRol = item.MineSiteUserRole) === null || _item$MineSiteUserRol === void 0 ? void 0 : _item$MineSiteUserRol.source) !== e) {
                var _rolesList;
                const result = (_rolesList = rolesList) === null || _rolesList === void 0 ? void 0 : _rolesList.filter(obj => {
                  return obj.name === e;
                });
                this.updateUsersAppRole(item, result, 'index');
              }
            },
            value: valueofRoles,
            disabled: statusVal.indexOf('remove') !== -1
          }) : /*#__PURE__*/_react.default.createElement("div", null, item.MineSiteUserRole.value));
          return roleDropdownTemplate;
        }
      }, {
        label: _viewUsersconstants.CONSTANTS.REMOVE_ACCESS,
        key: 'MineSiteUserRemoveAccess',
        type: 'string',
        sortable: false,
        filterable: false,
        renderFn: item => {
          let rolesList = [];
          const roles = (0, _common.formatRoleDropDownValues)(rolesListData, 'appRoleDisplayName');
          rolesList = roles.roleNames.filter((thing, ind, self) => ind === self.findIndex(t => t.value === thing.value));
          const statusVal = item.MineSiteUserStatus.source ? item.MineSiteUserStatus.source.toLowerCase() : '-';
          let enableDsiableStatus = false;
          for (let i = 0; i < rolesList.length; i++) {
            if (rolesList[i].value.trim().toLowerCase() === item.MineSiteUserRole.source.trim().toLowerCase() && statusVal.indexOf('remove') === -1) {
              if (rolesList.length > 1) {
                enableDsiableStatus = true;
              }
            }
          }
          let template;
          if (statusVal.indexOf('remove') === -1 && enableDsiableStatus) {
            template = /*#__PURE__*/_react.default.createElement("div", {
              className: _viewUsersModule.default.cellWrapper
            }, /*#__PURE__*/_react.default.createElement("span", {
              className: _viewUsersModule.default.iconWrap,
              onClick: e => this.props.deleteModaltrigger(item, e, 'index'),
              "data-test": 'delete'
            }, /*#__PURE__*/_react.default.createElement(_oneWeir.Icon, {
              width: "16px",
              height: "16px",
              icon: "trash"
            })));
          } else {
            template = /*#__PURE__*/_react.default.createElement("div", {
              className: _viewUsersModule.default.cellWrapper
            }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_oneWeir.Icon, {
              width: "16px",
              state: 'disabled',
              height: "16px",
              icon: "trash"
            })));
          }
          return template;
        }
      }],
      data: []
    };

    //changes to sort data if sort required is true
    const updatedData = isSort ? (0, _sortHelper.StringSortHelper)(data, sortKey, sortOrder) : data;
    let rolesList = [];
    updatedData.sort().map((item, index) => {
      tableData.data.push({
        MineSiteUsers: item.displayName || '--',
        MineSiteUserStatus: item.status || '--',
        MineSiteUserLastLogin: item.lastLogin || '--',
        MineSiteUserRole: item.appRoleName || '--',
        MineSiteUserRemoveAccess: item.status || '--',
        MineSiteUsersEmail: item.email || '--',
        MineSiteUserObjectId: item.objectId || '--',
        MineSiteUserappRoleObjectId: item.appRoleObjectId || '--'
      });
    });
    this.setState(() => ({
      tableHeaders: null,
      tableSrcData: null
    }), () => {
      this.setState({
        tableHeaders: tableData.tableHeaders,
        tableSrcData: tableData.data
      });
    });
    return tableData;
  }
  onClickUser(item) {
    this.props.userDetailsCallback(item);
  }
  onClickAddTeamMember() {
    this.props.viewUsersAddTeamMemberCallback();
  }
  updateUsersAppRole(item, selectedRole, i) {
    try {
      const values = [...this.state.values];
      if (values && values.length > 0) {
        this.setState({
          values,
          onRoleChange: true
        }, () => {
          var _item$MineSiteUserapp, _selectedRole$, _item$MineSiteUserObj, _this$props$businessE;
          const reqBody = {
            applicationID: this.props.applicationID,
            appRoleObjectId: item === null || item === void 0 || (_item$MineSiteUserapp = item.MineSiteUserappRoleObjectId) === null || _item$MineSiteUserapp === void 0 ? void 0 : _item$MineSiteUserapp.source,
            updatedAppRoleId: (_selectedRole$ = selectedRole[0]) === null || _selectedRole$ === void 0 ? void 0 : _selectedRole$.appRoleObjectId,
            userObjectId: item === null || item === void 0 || (_item$MineSiteUserObj = item.MineSiteUserObjectId) === null || _item$MineSiteUserObj === void 0 ? void 0 : _item$MineSiteUserObj.source,
            businessEntityObjectId: (_this$props$businessE = this.props.businessEntity) === null || _this$props$businessE === void 0 ? void 0 : _this$props$businessE.businessEntityObjectId
          };
          this.props.updateUserRole(reqBody);
        });
      }
      window.scrollTo(0, 0);
    } catch (e) {
      console.log('viewUsersUpdateRole', e);
    }
  }
  breadcrumbInitialize() {
    const breadcrumbHistoryData = [];
    breadcrumbHistoryData.push({
      path: '#',
      title: _languageMsg.default.MANAGE_YOUR_TEAM,
      callbackHandler: () => this.props.navCallback(0)
    });
    breadcrumbHistoryData.push({
      path: '#',
      title: this.props.mineSiteLabel.singular
    });
    this.setState({
      breadcrumbHistoryData
    });
  }
  deleteFooterContent() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _viewUsersModule.default.footerContent
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _viewUsersModule.default.margin25
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
      disabled: false,
      label: _languageMsg.default.CANCEL,
      variant: "secondary",
      onClick: () => {
        this.props.deleteModaltrigger();
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _viewUsersModule.default.margin25
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
      disabled: false,
      label: _languageMsg.default.REMOVE_ACCESS,
      variant: "primary",
      onClick: () => {
        this.props.onDeleteAccess();
      }
    })));
  }
  render() {
    const {
      businessEntity,
      deleteUserData
    } = this.props;
    const {
      tableHeaders,
      tableSrcData
    } = this.state;
    if (this.state.breadcrumbHistoryData === undefined) {
      this.breadcrumbInitialize();
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "view-users-page",
      className: _viewUsersModule.default.wrapper
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Modal, {
      showModal: this.props.deleteModal,
      onClose: () => {
        this.props.deleteModaltrigger();
      },
      size: 'small',
      dismissable: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _viewUsersModule.default.modalPadding
    }, ViewUsersPage.deleteBodyContent(deleteUserData ? deleteUserData.MineSiteUsersEmail.source : ''), this.deleteFooterContent())), /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "view-users-breadcrumb"
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.Breadcrumb, {
      breadcrumbHistory: this.state.breadcrumbHistoryData
    })), /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "view-users-table",
      className: _viewUsersModule.default.paddingTop20
    }, tableSrcData && /*#__PURE__*/_react.default.createElement(_weirDls.Table, {
      sortable: true,
      header: tableHeaders,
      source: tableSrcData,
      title: businessEntity.sourceSystemBusinessEntityDisplayName,
      searchable: true,
      minSearch: 3,
      searchPlaceHolderOnFocus: _constants.tableConstants.SEARCH_PLACEHOLDER_ONFOCUS,
      searchResultSingle: _constants.tableConstants.RESULTS_LBL_SINGULAR,
      searchResultPlural: _constants.tableConstants.RESULTS_LBL_PLURAL,
      noResultsText: _constants.tableConstants.NO_RESULTS_LBL,
      searchPlaceholder: _constants.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
      primaryActionBtnTitle: 'Add Team Members',
      onPrimaryActionBtnClick: this.onClickAddTeamMember,
      serverSideSort: false,
      serverSideSearch: false
    })));
  }
}
const mapStateToProps = state => ({
  users: state.manageYourTeam.users,
  roles: state.manageYourTeam.roles,
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
function mapDispatchToProps(dispatch) {
  return {
    getUsersForSelectedBusinessEntity: (appID, businessEntityID) => {
      dispatch((0, _manageYourTeam.getUsersForSelectedBusinessEntity)(appID, businessEntityID));
    },
    updateUserRole: data => {
      dispatch((0, _manageYourTeam.updateUserRole)(data));
    }
  };
}
;
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ViewUsersPage);